import Table from './Table';
import './style/index';
export default Table;